import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { ConditionalQuestionLabel } from 'components/ConditionalQuestion';
import generateQuestionFormName from 'utils/generateQuestionFormName';

import MatrixQuestionForm from './MatrixQuestionForm';
import TextQuestionRichText from '../../../domains/richText/components/TextQuestionRichText';
import propTypeBlockStyling from '../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

const MatrixQuestion = ({
  block,
  block: { clientUuid, content, required },
  isCloned,
  isInPreviewMode = false,
  inputRowField,
  onAnswer,
  answer,
  styling,
  questionNumber,
}) => {
  const isConditionalQuestion = useMemo(() => !!(block.logic && block.logic.message), [block.logic]);

  return (
    <div>
      {isInPreviewMode &&
        isConditionalQuestion && <ConditionalQuestionLabel enableMessage={block.logic.message} />}
      <TextQuestionRichText
        questionNumber={questionNumber}
        content={content}
        required={required}
        styling={styling}
      />
      <MatrixQuestionForm
        form={generateQuestionFormName(clientUuid, isCloned)}
        block={block}
        inputRowField={inputRowField}
        onSubmit={onAnswer}
        initialValues={answer}
        styling={styling}
      />
    </div>
  );
};

MatrixQuestion.propTypes = {
  block: PropTypes.shape({
    clientUuid: PropTypes.string.isRequired,
    required: PropTypes.bool,
    content: PropTypes.object,
  }).isRequired,
  isCloned: PropTypes.bool,
  isInPreviewMode: PropTypes.bool,
  onAnswer: PropTypes.func.isRequired,
  inputRowField: PropTypes.func.isRequired,
  answer: PropTypes.shape({
    value: PropTypes.object,
    comments: PropTypes.string,
  }),
  styling: propTypeBlockStyling,
  questionNumber: PropTypes.number,
};

export default MatrixQuestion;
